import { render, staticRenderFns, recyclableRender, components } from "./detail.vue?vue&type=template&id=7086dab0&scoped=true&"
var renderjs
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=7086dab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086dab0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/announcement/detail.vue"
export default component.exports